import React, {useEffect, useState} from "react";


const GlobalApiError = () => {

    const [error,setError] = useState(null);
    useEffect(()=>{
        const handler = (event)=>{
            setError(event.detail.type);
        };

        const online = ()=>{
            setError(null);
        };


        window.addEventListener(
            "globalApiError",
            handler
        );

        window.addEventListener(
            "online",
            online
        );


        return ()=>{
            window.removeEventListener(
                "globalApiError",
                handler
            );

            window.removeEventListener(
                "online",
                online
            );
        };
    },[]);

    if(!error){
        return null;
    }

    return (
        <></>
        // <div className="alert alert-danger text-center mb-0">
        //     {
        //         error === "NETWORK"
        //             ?
        //             "インターネット接続を確認してください。"
        //             :
        //             "現在、サービスに問題が発生しています。"
        //     }
        //
        // </div>

    );

};


export default GlobalApiError;